import { render, staticRenderFns } from "./ListTableSimple.vue?vue&type=template&id=08392d94&"
import script from "./ListTableSimple.vue?vue&type=script&lang=js&"
export * from "./ListTableSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports